export const GET_NOTIFICATIONS = 'getNotifications'
export const SET_NOTIFICATIONS = 'setNotifications'
export const MARK_AS_READ_NOTIFICATIONS = 'markAsReadNotifications'
